import React from 'react';
import Button from '../../components/button';

import handleChat from '../../utils/handle-chat';

const features = [
  {
    name: '聊天链接',
    price: '10元/月'
  },
  {
    name: '快捷回复',
    price: '10元/月'
  },
  {
    name: '对话基础分配',
    price: '10元/月'
  },
  {
    name: '对话协作',
    price: '10元/月'
  },
  {
    name: '自定义样式',
    price: '10元/月'
  },
  {
    name: '客服评价',
    price: '10元/月'
  },
  {
    name: '自动消息',
    price: '10元/月'
  },
  {
    name: '个性化欢迎语',
    price: '10元/月'
  },
  {
    name: '历史对话',
    price: '10元/月'
  },
  {
    name: '对话规则',
    price: '10元/月'
  },
  {
    name: '访客管理',
    price: '20元/月'
  },
  {
    name: '顾客中心基础',
    price: '20元/月'
  },
  {
    name: '报表',
    price: '20元/月'
  }
];

const Price1 = () => {
  return (
    <div className="price-wrapper">
      <div className="price-header">
        <p>
          入门套餐<i className="tag">8折优惠</i>
        </p>
        <p>包含5个坐席</p>
      </div>
      <div className="price-content">
        <p className="font-24">¥1632元/年</p>
        <p className="count-price">
          <span className="font-36">￥</span>
          <span className="font-68">980</span>
          <span className="font-16">元/年</span>
        </p>
        <div className="btn">
          <Button type="primary" onClick={() => handleChat('立即购买入门套餐', ['d7', 'type1'])}>
            立即购买
          </Button>
        </div>
        <p className="desc">
          包含 <i className="tag">基础产品</i> 功能，以及
        </p>
        <ul>
          {features.map((f, i) => (
            <li key={i}>
              <span>
                <span className="dot" />
                {f.name}
              </span>
              <span>{f.price}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="price-btn">
        <Button onClick={() => handleChat('免费试用入门套餐', ['d7', 'type2'])}>免费试用</Button>
      </div>
    </div>
  );
};

export default Price1;
